var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VDialog',{attrs:{"max-width":"600"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_c('Chip',{attrs:{"status":_vm.value}})],1)]}}])},[_c('CardHistory')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }